module.exports = __webpack_public_path__ + "static/95913677-1468990a12451415a3c12b2a1a2ddd16.jpg";